import React, { useState } from 'react'
import { IconButton } from '@material-ui/core'
import { CalendarToday, ArrowDropDown } from '@material-ui/icons'
import { FieldProps } from 'formik'
import { ICaptionOption } from '../../types/datafile'
import { CustomTextField } from '../CustomTextField'
import { ICustomTextFieldProps } from '../CustomTextField/CustomTextField'
import { OptionsList } from './OptionsList'
import { StyledDatePicker } from './StyledDatePicker'

interface ICustomDateListField extends ICustomTextFieldProps {
  listOptions: ICaptionOption[]
}

export const CustomDateListField = ({
  listOptions,
  ...props
}: FieldProps<any> & ICustomDateListField) => {
  const { form, field, disabled } = props
  const [datePickerOpened, setDatePickerOpened] = useState(false)
  const [listOpened, setListOpened] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null) as any

  const handleListSelect = (value: string): void => {
    form.setFieldValue(field.name, value)
    setListOpened(false)
  }

  const handleDateSelect = (value: string): void => {
    form.setFieldValue(field.name, value)
    setDatePickerOpened(false)
  }

  const openList = ({ currentTarget }: any): void => {
    setAnchorEl(currentTarget)
    setDatePickerOpened(false)
    setListOpened(!listOpened)
  }

  const openDatePicker = (): void => {
    setDatePickerOpened(!datePickerOpened)
    setListOpened(false)
  }

  return (
    <>
      <CustomTextField
        {...props}
        endAdornment={
          <>
            <IconButton id="toggle-list" onClick={openList} disabled={disabled}>
              <ArrowDropDown
                fontSize="small"
                color={disabled ? 'disabled' : 'primary'}
              />
            </IconButton>
            <IconButton
              id="toggle-datepicker"
              onClick={openDatePicker}
              disabled={disabled}
            >
              <CalendarToday
                fontSize="small"
                color={disabled ? 'disabled' : 'primary'}
              />
            </IconButton>
          </>
        }
      />
      <StyledDatePicker
        open={datePickerOpened}
        selected={field.value}
        onChange={handleDateSelect}
      />
      <OptionsList
        open={listOpened}
        onClose={() => setListOpened(false)}
        anchorEl={anchorEl}
        listOptions={listOptions}
        onSelect={handleListSelect}
      />
    </>
  )
}
